import { State, Subscription } from "../types/Constants";
import { Role } from "../types/role";

export const subscriptions: Subscription[] = [
  { label: "Sherpa", value: "SHERPA" },
  { label: "Sherpa Co-Op", value: "SHERPA_CO_OP" },
  { label: "Rover", value: "ROVER" },
];

export const States: State[] = [
  { name: "Alabama", abbreviation: "AL" },
  { name: "Alaska", abbreviation: "AK" },
  { name: "American Samo", abbreviation: "AS" },
  { name: "Arizona", abbreviation: "AZ" },
  { name: "Arkansas", abbreviation: "AR" },
  { name: "California", abbreviation: "CA" },
  { name: "Colorado", abbreviation: "CO" },
  { name: "Connecticut", abbreviation: "CT" },
  { name: "Delaware", abbreviation: "DE" },
  { name: "District Of Columbia", abbreviation: "DC" },
  { name: "Federated States Of Micronesia", abbreviation: "FM" },
  { name: "Florida", abbreviation: "FL" },
  { name: "Georgia", abbreviation: "GA" },
  { name: "Guam", abbreviation: "GU" },
  { name: "Hawaii", abbreviation: "HI" },
  { name: "Idaho", abbreviation: "ID" },
  { name: "Illinois", abbreviation: "IL" },
  { name: "Indiana", abbreviation: "IN" },
  { name: "Iowa", abbreviation: "IA" },
  { name: "Kansas", abbreviation: "KS" },
  { name: "Kentucky", abbreviation: "KY" },
  { name: "Louisiana", abbreviation: "LA" },
  { name: "Maine", abbreviation: "ME" },
  { name: "Marshall Islands", abbreviation: "MH" },
  { name: "Maryland", abbreviation: "MD" },
  { name: "Massachusetts", abbreviation: "MA" },
  { name: "Michigan", abbreviation: "MI" },
  { name: "Minnesota", abbreviation: "MN" },
  { name: "Mississippi", abbreviation: "MS" },
  { name: "Missouri", abbreviation: "MO" },
  { name: "Montana", abbreviation: "MT" },
  { name: "Nebraska", abbreviation: "NE" },
  { name: "Nevada", abbreviation: "NV" },
  { name: "New Hampshire", abbreviation: "NH" },
  { name: "New Jersey", abbreviation: "NJ" },
  { name: "New Mexico", abbreviation: "NM" },
  { name: "New York", abbreviation: "NY" },
  { name: "North Carolina", abbreviation: "NC" },
  { name: "North Dakota", abbreviation: "ND" },
  { name: "Northern Mariana Islands", abbreviation: "MP" },
  { name: "Ohio", abbreviation: "OH" },
  { name: "Oklahoma", abbreviation: "OK" },
  { name: "Oregon", abbreviation: "OR" },
  { name: "Palau", abbreviation: "PW" },
  { name: "Pennsylvania", abbreviation: "PA" },
  { name: "Puerto Rico", abbreviation: "PR" },
  { name: "Rhode Island", abbreviation: "RI" },
  { name: "South Carolina", abbreviation: "SC" },
  { name: "South Dakota", abbreviation: "SD" },
  { name: "Tennessee", abbreviation: "TN" },
  { name: "Texas", abbreviation: "TX" },
  { name: "Utah", abbreviation: "UT" },
  { name: "Vermont", abbreviation: "VT" },
  { name: "Virgin Islands", abbreviation: "VI" },
  { name: "Virginia", abbreviation: "VA" },
  { name: "Washington", abbreviation: "WA" },
  { name: "West Virginia", abbreviation: "WV" },
  { name: "Wisconsin", abbreviation: "WI" },
  { name: "Wyoming", abbreviation: "WY" },
];

export const SageRoles = [
  {
    label: "Super Admin",
    value: "SUPER_ADMIN",
  },
  {
    label: "Admin",
    value: "ADMIN",
  },
  {
    label: "Client Manager",
    value: "CLIENT_MANAGER",
  },
  {
    label: "Account User",
    value: "ACCOUNT_USER",
  },
];

export const ClientRoles: Role[] = [
  {
    label: "Super Admin",
    value: "SUPER_ADMIN",
  },
  {
    label: "Admin",
    value: "ADMIN",
  },
  {
    label: "Project Manager",
    value: "PROJECT_MANAGER",
  },
  {
    label: "Project Associate",
    value: "PROJECT_ASSOCIATE",
  },
  {
    label: "Observer",
    value: "OBSERVER",
  },
];

export const getRolesListFor = (role: string, account: string) => {
  if (account === "sageadmin") {
    return (
      {
        SUPER_ADMIN: SageRoles,
        ADMIN: SageRoles.filter(
          (r) => !["SUPER_ADMIN", "ADMIN"].includes(r.value)
        ),
      }[role] || []
    );
  } else {
    return (
      {
        SUPER_ADMIN: ClientRoles,
        ADMIN: ClientRoles.filter(
          (r) => !["SUPER_ADMIN", "ADMIN"].includes(r.value)
        ),
      }[role] || []
    );
  }
};

export const VendorCategory: { [key: number]: string } = {
  236115: "New Single-Family Housing Construction (except For-Sale Builders)",
  236116: "New Multifamily Housing Construction (except For-Sale Builders)",
  236117: "New Housing For-Sale Builders",
  236118: "Residential Remodelers",
  236210: "Industrial Building Construction",
  236220: "Commercial and Institutional Building Construction",
  237110: "Water and Sewer Line and Related Structures Construction",
  237120: "Oil and Gas Pipeline and Related Structures Construction",
  237130: "Power and Communication Line and Related Structures Construction",
  237210: "Land Subdivision",
  237310: "Highway, Street, and Bridge Construction",
  237990: "Other Heavy and Civil Engineering Construction",
  238110: "Poured Concrete Foundation and Structure Contractors",
  238120: "Structural Steel and Precast Concrete Contractors",
  238130: "Framing Contractors",
  238140: "Masonry Contractors",
  238150: "Glass and Glazing Contractors",
  238160: "Roofing Contractors",
  238170: "Siding Contractors",
  238190: "Other Foundation, Structure, and Building Exterior Contractors",
  238210: "Electrical Contractors and Other Wiring Installation Contractors",
  238220: "Plumbing, Heating, and Air-Conditioning Contractors",
  238290: "Other Building Equipment Contractors",
  238310: "Drywall and Insulation Contractors",
  238320: "Painting and Wall Covering Contractors",
  238330: "Flooring Contractors",
  238340: "Tile and Terrazzo Contractors",
  238350: "Finish Carpentry Contractors",
  238390: "Other Building Finishing Contractors",
  238910: "Site Preparation Contractors",
  238990: "All Other Specialty Trade Contractors",
  522110: "Commercial Banking",
  522291: "Consumer Lending",
  522292: "Real Estate Credit",
  522298: "All Other Nondepository Credit Intermediation",
  522310: "Mortgage and Nonmortgage Loan Brokers",
  523110: "Investment Banking and Securities Dealing",
  523120: "Securities Brokerage",
  523140: "Commodity Contracts Brokerage",
  523210: "Securities and Commodity Exchanges",
  523910: "Miscellaneous Intermediation",
  523920: "Portfolio Management",
  523930: "Investment Advice",
  523991: "Trust, Fiduciary, and Custody Activities",
  523999: "Miscellaneous Financial Investment Activities",
  524126: "Direct Property and Casualty Insurance Carriers",
  524127: "Direct Title Insurance Carriers",
  524130: "Reinsurance Carriers",
  524210: "Insurance Agencies and Brokerages",
  524291: "Claims Adjusting",
  524292: "Third Party Administration of Insurance and Pension Funds",
  524298: "All Other Insurance Related Activities",
  525110: "Pension Funds",
  525910: "Open-End Investment Funds",
  525920: "Trusts, Estates, and Agency Accounts",
  525990: "Other Financial Vehicles",
  531110: "Lessors of Residential Buildings and Dwellings",
  531120: "Lessors of Nonresidential Buildings (except Miniwarehouses)",
  531130: "Lessors of Miniwarehouses and Self-Storage Units",
  531190: "Lessors of Other Real Estate Property",
  531210: "Offices of Real Estate Agents and Brokers",
  531311: "Residential Property Managers",
  531312: "Nonresidential Property Managers",
  531320: "Offices of Real Estate Appraisers",
  531390: "Other Activities Related to Real Estate",
  532120:
    "Truck, Utility Trailer, and RV (Recreational Vehicle) Rental and Leasing",
  532210: "Consumer Electronics and Appliances Rental",
  532281: "Formal Wear and Costume Rental",
  532289: "All Other Consumer Goods Rental",
  532411:
    "Commercial Air, Rail, and Water Transportation Equipment Rental and Leasing",
  532412:
    "Construction, Mining, and Forestry Machinery and Equipment Rental and Leasing",
  532420: "Office Machinery and Equipment Rental and Leasing",
  532490:
    "Other Commercial and Industrial Machinery and Equipment Rental and Leasing",
  541110: "Offices of Lawyers",
  541120: "Offices of Notaries",
  541191: "Title Abstract and Settlement Offices",
  541199: "All Other Legal Services",
  541211: "Offices of Certified Public Accountants",
  541213: "Tax Preparation Services",
  541214: "Payroll Services",
  541219: "Other Accounting Services",
  541310: "Architectural Services",
  541320: "Landscape Architectural Services",
  541330: "Engineering Services",
  541340: "Drafting Services",
  541350: "Building Inspection Services",
  541360: "Geophysical Surveying and Mapping Services",
  541370: "Surveying and Mapping (except Geophysical) Services",
  541380: "Testing Laboratories",
  541410: "Interior Design Services",
  541420: "Industrial Design Services",
  541430: "Graphic Design Services",
  541490: "Other Specialized Design Services",
  541511: "Custom Computer Programming Services",
  541512: "Computer Systems Design Services",
  541513: "Computer Facilities Management Services",
  541519: "Other Computer Related Services",
  541611:
    "Administrative Management and General Management Consulting Services",
  541612: "Human Resources Consulting Services",
  541613: "Marketing Consulting Services",
  541614: "Process, Physical Distribution, and Logistics Consulting Services",
  541618: "Other Management Consulting Services",
  541620: "Environmental Consulting Services",
  541690: "Other Scientific and Technical Consulting Services",
  541810: "Advertising Agencies",
  541820: "Public Relations Agencies",
  541830: "Media Buying Agencies",
  541840: "Media Representatives",
  541850: "Outdoor Advertising",
  541860: "Direct Mail Advertising",
  541870: "Advertising Material Distribution Services",
  541890: "Other Services Related to Advertising",
  541910: "Marketing Research and Public Opinion Polling",
  541921: "Photography Studios, Portrait",
  541922: "Commercial Photography",
  541930: "Translation and Interpretation Services",
  541990: "All Other Professional, Scientific, and Technical Services",
  561110: "Office Administrative Services",
  561210: "Facilities Support Services",
  561311: "Employment Placement Agencies",
  721110: "Hotels (except Casino Hotels) and Motels",
  721120: "Casino Hotels",
  721191: "Bed-and-Breakfast Inns",
  721199: "All Other Traveler Accommodation",
  721211: "RV (Recreational Vehicle) Parks and Campgrounds",
  721310: "Rooming and Boarding Houses, Dormitories, and Workers' Camps",
  722310: "Food Service Contractors",
  722320: "Caterers",
  722330: "Mobile Food Services",
  722511: "Full-Service Restaurants",
  722513: "Limited-Service Restaurants ",
};

export const sourcesList: string[] = [
  "ARPA Funds",
  "C-PACE",
  "CDBG Funds",
  "CDBG-DR",
  "Debt-Bank",
  "Debt-Non-Bank",
  "Debt-Philanthropic",
  "Debt-Mezzanine",
  "Equity-Developer",
  "Equity-Investor",
  "Equity-Philanthropic",
  "HOME ARPA Funds",
  "HOME Funds",
  "PACE",
  "Tax Credit Equity-LIHTC",
  "Tax Credit Equity-NMTC",
  "Tax Credit Equity-HTC",
  "Tax Credit Equity-Solar",
];

export const usesList: string[] = [
  "Acquisition",
  "Architect",
  "Civil Engineer",
  "Connection Fees",
  "Consultants",
  "Construction-Site Work",
  "Construction-Demolition",
  "Construction-Hard Costs",
  "Construction-Builders Overhead & Profit",
  "Contingency",
  "Development Management ",
  "FF&E",
  "Financing",
  "Geotechnical ",
  "Impact Fees ",
  "Interior Designer ",
  "Insurance",
  "Landscape Architect",
  "Legal",
  "Market Study",
  "Marketing ",
  "Permitting",
  "Reserves",
  "Soft Costs",
  "Specialty Construction-Roof",
  "Specialty Construction-Plumbing",
  "Specialty Construction-Electrical",
  "Specialty Construction-HVAC",
  "Specialty Construction-Painting",
  "Specialty Construction-Millwork",
  "Specialty Construction-Flooring",
  "Specialty Construction-Exterior Decking",
  "Specialty Construction-Window Replacement",
  "Specialty Construction-Foundation",
  "Specialty Construction-Structural",
  "Specialty Construction-Gutters",
  "Specialty Construction-Utility Connection",
  "Structural Engineer",
  "Survey",
];
